module.exports = __webpack_public_path__ + "static/media/header_empfangen.5749cb23.jpg";